import React from 'react'
import { AlertMessage } from 'cdh-data-portal-theme'
import type { Notice } from '../DataGovernorsPage.logic'
import type { useStyles } from '../DataGovernorsPage.style'
import { localText } from './RegistryFeedback.static'

export interface RegistryFeedbackProps {
  readonly classes: ReturnType<typeof useStyles>['classes']
  readonly error: string | null
  readonly onDismissError: () => void
  readonly notice: Notice | null
  readonly onDismissNotice: () => void
  readonly isLoading: boolean
  readonly hasLoaded: boolean
}

export const RegistryFeedback: React.FC<RegistryFeedbackProps> = ({
  classes,
  error,
  onDismissError,
  notice,
  onDismissNotice,
  isLoading,
  hasLoaded,
}) => (
  <>
    {error && (
      <AlertMessage
        className={classes.feedback}
        closeAction={onDismissError}
        message={error}
        title={localText.registryRequestFailedTitle}
        variant="error"
      />
    )}
    {notice && (
      <AlertMessage
        className={classes.feedback}
        closeAction={onDismissNotice}
        message={notice.message}
        title={notice.title}
        variant={notice.variant}
      />
    )}
    {isLoading && !hasLoaded && (
      <AlertMessage className={classes.feedback} isLoading title={localText.loadingTitle} variant="info" />
    )}
  </>
)
